import CartManager from './CartManager';

document.addEventListener('DOMContentLoaded', (e) => {
  const cartManager = new CartManager(document);
  cartManager.mount();
});
